// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteConfirmationDialogStyles_container__t_8M6","text":"DeleteConfirmationDialogStyles_text__1dZcJ","buttons":"DeleteConfirmationDialogStyles_buttons__94gbN"};